<m-videoPlayer
  [guid]="guid"
  [shouldPlayInModal]="shouldPlayInModal"
  [isModal]="isModal"
  (mediaModalRequested)="openModal($event)"
></m-videoPlayer>

<div
  class="m-videoPlayer--scrollaware__overlay"
  style="
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    pointer-events: none;
  "
  (click)="onOverlayClick($event)"
></div>
